import React from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../contexts/UserContext";
import { URL_PATHS } from "../utils/routeUtils";
import { Popup } from "./Popup";
import { MORATORIUM_BODY_COPY, MORATORIUM_TITLE } from "./moratoriumCopy";

/**
 * Renders a blocking popup when the current customer has an active moratorium.
 * Drop into any credit-related page (loans landing, loan application, etc.)
 * so direct-URL navigation is intercepted as well as in-app links.
 *
 * When `show_credit_tile` is true / unknown the component renders nothing.
 */
const MoratoriumGuard: React.FC = () => {
  const { creditEligibility } = useUser();
  const navigate = useNavigate();

  const isBlocked = creditEligibility?.show_credit_tile === false;

  const handleAcknowledge = () => navigate(URL_PATHS.CUSTOMER_HOME);

  if (!isBlocked) return null;

  return (
    <Popup
      isOpen={true}
      title={MORATORIUM_TITLE}
      onClose={handleAcknowledge}
      closeOnBackdropClick={false}
      closeOnEscape={false}
      autoHeight
      className="!max-w-md"
      buttons={[
        {
          text: "OK",
          onClick: handleAcknowledge,
          variant: "secondary",
        },
      ]}
    >
      <p>{MORATORIUM_BODY_COPY}</p>
    </Popup>
  );
};

export default MoratoriumGuard;
